import React, { useState } from 'react';
import {
  IconButton,
  Popover,
  Typography,
  Box,
} from '@mui/material';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import "./InfoDropDown.css";
import { OutletApprovalDropDownProps } from './ViewOrderType';
import { approvalStatusMapping } from '../stocks/manualStockAdjustment/ManualStockAdjustmentUtils';

const InfoDropDown: React.FC<OutletApprovalDropDownProps> = ({
  approvalStatus = "",
  approvedBy = "",
  approvedDate = "",
  approvalReason = "",
}) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  
  // if (approvalStatus.length === 0) return

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (approvalStatus === "PENDING") return
    event.stopPropagation();
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  const open = Boolean(anchorEl);

  const statusMap = {
    APPROVED: {
      statusText: "Outlet approved successfully",
      byLabel: "Approved by",
      dateLabel: "Approved on",
      showReason: false,
      showDropDown: true,
      color: "#22b655",
      bgColor: "#F3FCF3",
    },
    REJECTED: {
      statusText: "Outlet approval rejected",
      byLabel: "Rejected by",
      dateLabel: "Rejected on",
      showReason: true,
      showDropDown: true,
      color: "#D93D3E",
      bgColor: "#FFF9F8",
    },
    PENDING: {
      statusText: "Outlet approval in progress",
      byLabel: "",
      dateLabel: "",
      showReason: false,
      showDropDown: false,
      color: "#CC911F",
      bgColor: "#FFF9EF",
    },
  } as const;

  const config = statusMap[approvalStatus as keyof typeof statusMap] ?? statusMap.PENDING;

  return (
    <Box display="flex" alignItems="center" onClick={handleClick} style={{ padding: 5, marginLeft: 5 }}>
      {/* Preview Text */}
      <Typography
        sx={{
          textDecoration: 'underline',
          color: config.color,
          fontSize: '13px',
          fontWeight: 500,
        }}
      >
        {config.statusText}
      </Typography>

      {/* Arrow Icon */}
      {config.showDropDown && (<IconButton
        disableRipple
        disableFocusRipple 
        sx={{
          transform: open ? "rotate(180deg)" : "rotate(0deg)",
          transition: "transform 0.3s ease",
          color: config.color,
          padding: 0,
          "&:hover": {
            backgroundColor: "transparent", // removes red hover bg
            color: config.color
          },
        }}
      >
        <ArrowDropDownIcon fontSize="medium" />
      </IconButton>)}

      {/* Popover */}
      {config.showDropDown && (<Popover
        open={open}
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
        PaperProps={{
          sx: {
            padding: '12px',
            borderRadius: '5px',
            width: '280px',
            border: `0.5px solid ${config.color}`,
            backgroundColor: config.bgColor,
            boxShadow: '1px 1px 4px rgba(0, 0, 0, 0.1)'
          },
        }}
      >
        <Box>
          {config.byLabel && (
            <Typography  sx={{ fontSize: '11px',mb: 0.5 }}>
              <span className='outlet-approval-body-label'>{`${config.byLabel}:`}</span> <span className='outlet-approval-body-value'>{approvedBy}</span>
            </Typography>
          )}

          {config.dateLabel && (
            <Typography  sx={{ fontSize: '11px'}}>
              <span className='outlet-approval-body-label'>{`${config.dateLabel}:`}</span> <span className='outlet-approval-body-value'>{approvedDate}</span>
            </Typography>
          )}

          {config.showReason && approvalReason && (
            <Box
              mt={1}
              p={1}
              bgcolor="white"
              borderRadius="6px"
            >
              <Typography sx={{ fontSize: '11px' }}>
                <span className='outlet-approval-body-label'>Rejection Reason</span>
              </Typography>
              <Typography sx={{ fontSize: '11px'}}>{approvalReason}</Typography>
            </Box>
          )}
        </Box>
      </Popover>)}
    </Box>
  );
};

export default InfoDropDown;
